import { isMobile } from '../utils/base-init'
import initJQueryValidation from '../utils/init-jquery-validation'


// interface Rules {
// 	[key: string]: string | object
// }

type Rules = Record<string, string | object>

const COUNTRIES_WITHOUT_ZIP = ['237', '101']

export function mergeRules(currentCountry, rules) {
	return COUNTRIES_WITHOUT_ZIP.includes(currentCountry) ?
		rules :
		{ ...rules, zip: 'required' }
}

const shippingRules = (): Rules => {
	const rules = {
		midDelivery: 'required',
		firstName: 'required',
		lastName: 'required',
		// konbiniLastName: 'required',
		email: {
			required: true,
			email: true
		}
	}
	if (!isMobile) {
		return { ...rules, 'email-capture': 'required' }
	}

	return rules
}

export function setShippingValidationRules() {
	const selectDomDesktop = document.querySelector('#select-mid-delivery')
	const selectDomMobile = document.querySelector('#select-mid-delivery-sm')

	if (selectDomDesktop) {
		window.deliveryMethod = selectDomDesktop
			.querySelector('option:checked')
			.getAttribute('data-delivery-type')
	} else if (selectDomMobile) {
		window.deliveryMethod = $('input[name=midDelivery]:checked').attr(
			'data-delivery-method'
		)
	}


	const currentCountry = (document.querySelector('#countryId') as HTMLSelectElement)?.value
	const rules: Rules = shippingRules()

	// additional rules logic for address, city, state and phone depending on delivery method
	switch (window.deliveryMethod) {
		// only for cases where everything is required so we need to merge these logic with the non zipcode required countries.
		case 'shipping':
		case 'collect_on_delivery':
			rules.address1 = 'required'
			rules.city = 'required'
			rules.stateId = { required: true }
			rules.phone = {
				required: true,
				phone: window.phoneCountryCode === 'us'
			}

			if (currentCountry) {
				initJQueryValidation(mergeRules(currentCountry, rules))
			}

			break
		case 'willcall':
		case 'pickup':
		case 'eticket':
			rules.phone = {
				required: true,
				phone: window.phoneCountryCode === 'us'
			}
			if (window.phoneCountryCode === 'jp') {
				rules.address1 = 'required'
				rules.city = 'required'
				rules.zip = 'required'
			}
			initJQueryValidation(rules)
			break
		default:
			rules.address1 = 'required'
			rules.city = 'required'
			rules.stateId = { required: true }
			rules.phone = {
				required: true,
				phone: window.phoneCountryCode === 'us'
			}

			if (currentCountry) {
				initJQueryValidation(mergeRules(currentCountry, rules))
			}

			break
	}
}

const creditCardRules = () => {
	const rules = {
		// creditCardName: 'required',
		creditCardNumber: {
			required: true,
			creditcard: true,
		},
		cvv2Number: 'required',
	}
	const ccElem = document.getElementById('creditCardNumber')
	const cardValue = ccElem ? (ccElem as HTMLInputElement).value : ''
	const cardList = ['1234123412341234', '5123459358515820', '4708224192406930', '5123459358515840', '5554307543057788']
	const isTestCard = cardList.includes(cardValue.replace(/\s+/g, ''))
	return ccElem && !isTestCard ? rules : {}
}

const billingRules = () => {
	return {
		// midDelivery: 'required',
		...creditCardRules(),
		firstNameBilling: 'required',
		lastNameBilling: 'required',
		address1Billing: 'required',
		zipBilling: 'required',
		cityBilling: 'required',
		phoneBilling: {
			required: true,
			phoneBilling: window.phoneCountryCodeBilling === 'us'
		},
		emailBilling: {
			required: true,
			email: true,
		},
		cpfBilling: {
			required: true,
			cpf: true,
		},
		cpfBillingPix: {
			required: true,
			cpf: true,
		},
	}
}

export function setBillingValidationRules() {
	const sameAsShipping = $('#sameAsShipping').is(':checked')
	// @ts-ignore
	const currentCountry = document.querySelector('#countryId')?.value

	if (sameAsShipping) {
		// console.info('sameAsShipping.is:checked')
	} else if (currentCountry) {
		initJQueryValidation(mergeRules(currentCountry, billingRules))
		// console.debug('sameAsShipping.is:not checked')
	}
}


export function setShippingBillingValidationRules() {
	console.debug('setShippingBillingValidationRules')
	const selectDomDesktop = document.querySelector('#select-mid-delivery')
	const selectDomMobile = document.querySelector('#select-mid-delivery-sm')

	if (selectDomDesktop) {
		window.deliveryMethod = selectDomDesktop
			.querySelector('option:checked')
			.getAttribute('data-delivery-type')
	} else if (selectDomMobile) {
		window.deliveryMethod = $('input[name=midDelivery]:checked').attr(
			'data-delivery-method'
		)
	}

	const sameAsShipping = $('#sameAsShipping').is(':checked')
	// @ts-ignore
	const currentCountry = document.querySelector('#countryId')?.value

	let rules
	// if (typeof ccElem !== 'undefined' && ccElem != null) {
	if (sameAsShipping) {
		rules = {
			...shippingRules(),
			...creditCardRules(),
		}
	} else {
		rules = {
			...shippingRules(),
			...creditCardRules(),
			address1Billing: 'required',
			zipBilling: 'required',
			cityBilling: 'required',
			phoneBilling: {
				required: true,
				phoneBilling: window.phoneCountryCodeBilling === 'us'
			},
			emailBilling: {
				required: true,
				email: true,
			},
			cpfBilling: {
				required: true,
				cpf: true,
			},
			cpfBillingPix: {
				required: true,
				cpf: true,
			},
		}
		if (window.phoneCountryCodeBilling === 'jp') {
			rules['address1'] = 'required'
			rules['city'] = 'required'
			rules['zip'] = 'required'
			rules['phone'] = {
				required: true,
				phone: window.phoneCountryCodeBilling === 'jp'
			}
		}

		if (window.koStore) {
			// do not require first name and last name for billing
		} else {
			rules.firstNameBilling = 'required'
			rules.lastNameBilling = 'required'
		}
	}

	// additional rules logic for address, city, state and phone depending on delivery method
	switch (window.deliveryMethod) {
		// only for cases where everything is required so we need to merge these logic with the non zipcode required countries.
		case 'shipping':
		case 'collect_on_delivery':
			rules.address1 = 'required'
			rules.city = 'required'
			rules.stateId = { required: true }
			rules.phone = {
				required: true,
				phone: window.phoneCountryCode === 'us'
			}

			if (currentCountry) {
				initJQueryValidation(mergeRules(currentCountry, rules))
			}

			break
		case 'willcall':
		case 'pickup':
		case 'eticket':
			rules.phone = {
				required: true,
				phone: window.phoneCountryCode === 'us'
			} // phone is always required now
			initJQueryValidation(rules)

			break
		case 'giftcard_email':
			initJQueryValidation(billingRules())
			// console.debug('setShippingBillingValidationRules: giftcard_email', rules)
			break
		default:
			rules.address1 = 'required'
			rules.city = 'required'
			rules.stateId = { required: true }
			rules.phone = {
				required: true,
				phone: window.phoneCountryCode === 'us'
			}

			if (currentCountry) {
				initJQueryValidation(mergeRules(currentCountry, rules))
			}
			// console.debug('setShippingBillingValidationRules: default', rules)

			break
	}
}
